import { FadeIn } from "./FadeIn";
import { ChefHat, Sparkles, BedDouble } from "lucide-react";
import { AMENITY_GUEST_ROOM_URL } from "@/config/assets";

const EVENT_TYPES = [
  "Pre-Wedding Photo Suites", "Marriages", "Ring Ceremonies", "Birthday Parties",
  "Family Functions", "Social Gatherings", "Conferences", "Corporate / Business Meets",
  "Concerts", "Fashion Shows", "Promotional Functions",
];

export const Amenities = () => (
  <section id="amenities" data-testid="amenities-section" className="bg-[#FAF9F6] py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <FadeIn>
        <p className="text-[#097969] uppercase tracking-[0.4em] text-xs mb-5">Caught in Style</p>
        <h2 className="font-serif-luxe text-4xl md:text-5xl font-medium text-[#043927] leading-tight">
          Amenities & <span className="italic">Events</span>
        </h2>
      </FadeIn>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        <FadeIn className="md:col-span-2">
          <div data-testid="amenity-card-kitchen" className="h-80 bg-[#043927] border border-[#D4AF37]/30 rounded-sm p-8 flex flex-col justify-end relative overflow-hidden transition-transform duration-500 hover:-translate-y-1.5">
            <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(circle at 70% 30%, #D4AF37 1px, transparent 1px)", backgroundSize: "30px 30px" }} />
            <ChefHat className="text-[#D4AF37] mb-3" size={28} strokeWidth={1.5} />
            <h3 className="font-serif-luxe text-2xl md:text-3xl text-[#FAF9F6]">Professional Event Kitchen</h3>
            <p className="text-[#FAF9F6]/75 text-sm mt-2 max-w-md">A state-of-the-art culinary space enabling flawless catering for up to 1,700 guests.</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15}>
          <div data-testid="amenity-card-washrooms" className="h-80 bg-[#043927] border border-[#D4AF37]/30 rounded-sm p-8 flex flex-col justify-end transition-transform duration-500 hover:-translate-y-1.5">
            <Sparkles className="text-[#D4AF37] mb-3" size={28} strokeWidth={1.5} />
            <h3 className="font-serif-luxe text-2xl md:text-3xl text-[#FAF9F6]">Luxury Washrooms</h3>
            <p className="text-[#FAF9F6]/75 text-sm mt-2">Immaculately maintained, premium fitted washrooms worthy of five-star hospitality.</p>
          </div>
        </FadeIn>

        <FadeIn className="md:col-span-3">
          <div data-testid="amenity-card-guest-rooms" className="group relative rounded-sm overflow-hidden h-72 border border-[#D4AF37]/30">
            <img src={AMENITY_GUEST_ROOM_URL} alt="Dedicated Guest Rooms" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#043927]/90 via-[#043927]/40 to-transparent" />
            <div className="absolute inset-y-0 left-0 p-8 flex flex-col justify-center max-w-lg">
              <BedDouble className="text-[#D4AF37] mb-3" size={28} strokeWidth={1.5} />
              <h3 className="font-serif-luxe text-2xl md:text-3xl text-[#FAF9F6]">Dedicated Guest Rooms</h3>
              <p className="text-[#FAF9F6]/75 text-sm mt-2">Six expansive air-conditioned suites offering your closest family a serene retreat during celebrations.</p>
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.1}>
        <div className="mt-20">
          <p className="text-[#097969] uppercase tracking-[0.4em] text-xs mb-8">One Venue, Every Occasion</p>
          <div data-testid="event-types-list" className="flex flex-wrap gap-3">
            {EVENT_TYPES.map((e) => (
              <span
                key={e}
                data-testid={`event-type-chip-${e.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="px-5 py-2.5 rounded-full border border-[#097969]/30 text-sm text-[#043927] bg-white cursor-default transition-colors duration-300 hover:bg-[#043927] hover:text-[#F3E5AB] hover:border-[#043927]"
              >
                {e}
              </span>
            ))}
          </div>
        </div>
      </FadeIn>
    </div>
  </section>
);
